import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=1f31a8d6&scoped=true"
import script from "./StatusIcon.vue?vue&type=script&lang=js"
export * from "./StatusIcon.vue?vue&type=script&lang=js"
import style0 from "./StatusIcon.vue?vue&type=style&index=0&id=1f31a8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f31a8d6",
  null
  
)

export default component.exports